"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _xstream = _interopRequireDefault(require("xstream"));

var _ramda = require("ramda");

var _common = require("./common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _default = function _default(l) {
  return (0, _ramda.unnest)(Object.keys(l).map(function (x) {
    var types = (0, _common.toHttpMethods)(x, l[x]);
    var typeSet = (0, _common.toSet)(x);
    var actionObject = l[x];
    return _toConsumableArray(types.map(function (type) {
      return function (s) {
        return {
          HTTP: (0, _common.ofType)(type[1], s.ACTION).map(function (a) {
            return Object.assign({}, (0, _ramda.omit)(['url', 'methods', 'type', 'after', 'path', 'body'], actionObject), {
              method: type[0],
              url: a.url,
              send: a.body,
              category: type[1],
              headers: type[0] === 'get' ? {} : {
                Authorization: localStorage.getItem('token')
              },
              path: a.path,
              params: a.params
            });
          })
        };
      };
    })).concat(_toConsumableArray(types.map(function (type) {
      return function (s) {
        return {
          ACTION: s.HTTP.select(type[1]).map(function (r) {
            return r.replaceError(function (error) {
              return _xstream.default.of(Object.assign(createSetAction(typeSet, type[0], actionObject, error.response), {
                error: {
                  source: type[1],
                  text: error.response && error.response.error && error.response.error.message,
                  status: error.response && error.response.status
                }
              }));
            });
          }).flatten().map(function (r) {
            return r.error ? r : createSetAction(typeSet, type[0], actionObject, r);
          })
        };
      };
    })));
  }));
};

exports.default = _default;

var getPayload = function getPayload(r, a, m) {
  var body = r.body,
      request = r.request;
  var params = request.params,
      send = request.send;
  var after = '' + (0, _common.upper)(m);
  if (a[after]) return a[after](body, params, send);
  if (a.after) return a.after(body, params, send);
  if (m === 'delete') return null;
  if (m === 'post' && send && !send.id && body && body.id) return Object.assign({}, send, {
    id: body.id
  });
  return (0, _common.hasBody)(m) ? send : body;
};

var createSetAction = function createSetAction(type, method, actionObject, response) {
  return {
    type: type,
    method: method,
    payload: getPayload(response, actionObject, method),
    path: response.request.path,
    params: response.request.params,
    statusCode: response.statusCode
  };
};